import defaultLogo from '../../../resource/favicon/android-chrome-384x384.png';
import defaultPayviewLogo from '../../../resource/favicon/payview/android-chrome-384x384.png';
import defaultBackground from '../../../resource/images/loginMo-bg.png';
import defaultBackgroundSmall from '../../../resource/images/loginMo-smallBg.jpg';
import defaultBackgroundPayview from '../../../resource/images/login-background.png';
import { getMainFavicon } from './getFavicons';


const setDomainInformationWithAssets = ({ assets, error, setDomain, isCustomPay }) => {
    if (assets && assets.background) {
        setDomain(assets);
    }
    else if (!assets || error) {
        setDomain({
            background: !isCustomPay ? defaultBackground : defaultBackgroundPayview,
            backgroundSmall: !isCustomPay ? defaultBackgroundSmall : null,
            pathFavicon: {
                android192x192: getMainFavicon(null, isCustomPay),
                android384x384: getMainFavicon(null, isCustomPay),
                apple144x144: getMainFavicon(null, isCustomPay),
                apple152x152: getMainFavicon(null, isCustomPay),
                base16x16: getMainFavicon(null, isCustomPay),
                base32x32: getMainFavicon(null, isCustomPay),
                ms144x144: getMainFavicon(null, isCustomPay)
            },
            pathLogo: !isCustomPay ? defaultLogo : defaultPayviewLogo
        });
    }

};
export default setDomainInformationWithAssets;